import {toAbsoluteUrl} from '_metronic/helpers'
import {FC} from 'react'
import Button from 'app/components/Button'

type Props = {
  onClickHandler?: () => void
}

const EditButton: FC<Props> = ({onClickHandler}) => {
  return (
    <Button
      style={
        {
          // backgroundColor:'#f5f5f5',
          // padding:'0px 12px',
          // marginRight:'4px'
          // border:'2px solid rgb(197, 197, 197)'
        }
      }
      onClick={onClickHandler}
      // onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
      //   (e.currentTarget.style.backgroundColor = '#ebebeb')
      // }
      // onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
      //   (e.currentTarget.style.backgroundColor = '#f5f5f5')
      // }
    >
      <img
        alt='edit-icon'
        src={toAbsoluteUrl('/media/icon/edit.svg')}
        className='me-2'
        style={{height: '18px', width: '18px'}}
      />
      <span>Edit</span>
    </Button>
  )
}

export default EditButton
